import { render, staticRenderFns } from "./ViewNews.vue?vue&type=template&id=ccfe4134&"
import script from "./ViewNews.vue?vue&type=script&lang=js&"
export * from "./ViewNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports